import React, { useState, useEffect } from 'react';
// import styles from './AdvancedEngineeringRCRA.module.scss';
import styles from '../../../BasicCleanupsFilter/BasicCleanupsFilter.module.scss';
import { CalciteCheckbox } from '@esri/calcite-components-react';


const options = {
  "Groundwater Controls": {
    param: "RCRA_EC_CODE='Y'",
    isIncluded: false,
    objectIds: null
  },
  "Non Groundwater Controls": {
    param:  "RCRA_EC_CODE='N'",
    isIncluded: false,
    objectIds: null
  },
  "No Control Information Reported": {
    param:  "RCRA_EC_CODE='U'",
    isIncluded: false,
    objectIds: null
  }
};
const AdvancedEngineeringRCRA = (props) => {
  const [checkboxDivArray, setCheckboxDivArray] = useState<Array<any>>([]);
  /* called every time a checkbox is checked or unchecked */
  const toggleParam = async (key) => {
    options[key].isIncluded = !options[key].isIncluded;
    passUpdatedParams();
  }

  // updates the brownfieldParam array stored in the parent component
  const passUpdatedParams = () => {
    let paramArray: Array<string> = [];
    for (let option in options) {
      if (options[option].isIncluded === true) {
        paramArray.push(options[option].param)
      }
    }
    // update the parameter stored in the parent component
    props.updateRCRAParams(paramArray);
  }

  const buildCheckboxDivs = (clear?) => {
    let tempArr: Array<any> = [];
    if (clear) {
      // the clear button was clicked, recreate checkboxes to be all unchecked
      for (let key in options) {
        options[key]["isIncluded"] = false;
        tempArr.push(
          <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
            <CalciteCheckbox name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
            <label className={styles.CheckboxLabels}>{key}</label>
          </div>
        );
      }
    } else {
      for (let key in options) {
        // clear button was not clicked, create checkboxes so that previously checked are still checked
        if (options[key]["isIncluded"] === true) {
          tempArr.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox checked name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        } else {
          tempArr.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        }
      }
    }
    passUpdatedParams();
    setCheckboxDivArray(tempArr);
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { buildCheckboxDivs(); }, [props.matchesAny]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { buildCheckboxDivs(true); }, [props.signalClear]);

  return (
    <div className={styles.Sections}>
    <div className={styles.SectionTitleDivs}>
      <label className={styles.FilterSectionLabels}>Control types are:</label>
    </div>
    <div className={styles.CheckboxSectionDivs}>
      {checkboxDivArray}
    </div>
  </div>
  );
}

export default AdvancedEngineeringRCRA;
